export function getIsUserProhibitedFromPerformingActions(adminFeatures, featureToggleList, candidateContext) {
  return (
    ((!!adminFeatures &&
      adminFeatures.AssistedCandidatePublish.IsEnabled &&
      featureToggleList.AssistedSourcing.IsEnabled) ||
      featureToggleList.ViewOnlyMode.IsEnabled) &&
    candidateContext === 'job'
  );
}

export function getIsFavouriteBucketEnabled(adminFeatures, featureToggleList, candidateContext) {
  return (
    ((!!adminFeatures &&
      adminFeatures.AssistedCandidatePublish.IsEnabled &&
      featureToggleList.AssistedSourcing.IsEnabled) ||
      featureToggleList.FavouriteBucket.IsEnabled) &&
    candidateContext === 'job'
  );
}

export const candidatePublishRecommendedStatuses = ['AssistedSourcing', 'LinkedinExtension', -15, 6];
